module.exports = __webpack_public_path__ + "static/media/participant-icon.654da52e.svg";